import { render, staticRenderFns } from "./TreatReport.vue?vue&type=template&id=0c5a771a&scoped=true"
import script from "./TreatReport.vue?vue&type=script&lang=js"
export * from "./TreatReport.vue?vue&type=script&lang=js"
import style0 from "./TreatReport.vue?vue&type=style&index=0&id=0c5a771a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a771a",
  null
  
)

export default component.exports